// Tutor Voice Selection Data
// Structured for Supabase migration with multi-language support

export const tutorVoiceSelectionData = {
  // Tutor Voice Selection Overview
  overview: {
    id: "tutor_voice_selection",
    title: {
      tc: "選擇正確的語氣由你來確定",
      sc: "选择正确的语气由你来确定",
      en: "Change Tutor Voice"
    },
    subtitle: {
      tc: "選擇最適合你的學習語調",
      sc: "选择最适合你的学习语调",
      en: "Choose the voice that best suits your learning style"
    },
    icon: "mic",
    color: "purple"
  },

  // Voice Options
  voiceOptions: {
    id: "voice_options",
    title: {
      tc: "語調選項",
      sc: "语调选项",
      en: "Voice Options"
    },
    voices: [
      {
        id: "american_female_1",
        accentName: {
          tc: "美式口音 (女)",
          sc: "美式口音 (女)",
          en: "American Accent (Female)"
        },
        countryCode: "US",
        flag: "🇺🇸",
        gender: "female",
        genderColor: "pink",
        characteristics: {
          tc: "開朗 尖銳 快速",
          sc: "开朗 尖锐 快速",
          en: "Cheerful Sharp Fast"
        },
        isSelected: false,
        previewUrl: "audio/american_female_1.mp3"
      },
      {
        id: "american_female_2",
        accentName: {
          tc: "美式口音 (女)",
          sc: "美式口音 (女)",
          en: "American Accent (Female)"
        },
        countryCode: "US",
        flag: "🇺🇸",
        gender: "female",
        genderColor: "pink",
        characteristics: {
          tc: "樂觀 活潑 熱情",
          sc: "乐观 活泼 热情",
          en: "Upbeat Lively Enthusiastic"
        },
        isSelected: false,
        previewUrl: "audio/american_female_2.mp3"
      },
      {
        id: "american_male_1",
        accentName: {
          tc: "美式口音 (男)",
          sc: "美式口音 (男)",
          en: "American Accent (Male)"
        },
        countryCode: "US",
        flag: "🇺🇸",
        gender: "male",
        genderColor: "blue",
        characteristics: {
          tc: "活潑 興奮 有趣",
          sc: "活泼 兴奋 有趣",
          en: "Lively Excited Fun"
        },
        isSelected: false,
        previewUrl: "audio/american_male_1.mp3"
      },
      {
        id: "australian_male_1",
        accentName: {
          tc: "澳洲口音 (男)",
          sc: "澳洲口音 (男)",
          en: "Australian Accent (Male)"
        },
        countryCode: "AU",
        flag: "🇦🇺",
        gender: "male",
        genderColor: "blue",
        characteristics: {
          tc: "開朗 尖銳 快速",
          sc: "开朗 尖锐 快速",
          en: "Cheerful Sharp Fast"
        },
        isSelected: false,
        previewUrl: "audio/australian_male_1.mp3"
      },
      {
        id: "british_female_1",
        accentName: {
          tc: "英式口音 (女)",
          sc: "英式口音 (女)",
          en: "British Accent (Female)"
        },
        countryCode: "GB",
        flag: "🇬🇧",
        gender: "female",
        genderColor: "pink",
        characteristics: {
          tc: "禮貌 優雅 清晰",
          sc: "礼貌 优雅 清晰",
          en: "Polite Elegant Clear"
        },
        isSelected: false,
        previewUrl: "audio/british_female_1.mp3"
      },
      {
        id: "british_male_1",
        accentName: {
          tc: "英式口音 (男)",
          sc: "英式口音 (男)",
          en: "British Accent (Male)"
        },
        countryCode: "GB",
        flag: "🇬🇧",
        gender: "male",
        genderColor: "blue",
        characteristics: {
          tc: "智慧 溫和 穩重",
          sc: "智慧 温和 稳重",
          en: "Wise Gentle Steady"
        },
        isSelected: false,
        previewUrl: "audio/british_male_1.mp3"
      },
      {
        id: "german_female_1",
        accentName: {
          tc: "德式口音 (女)",
          sc: "德式口音 (女)",
          en: "German Accent (Female)"
        },
        countryCode: "DE",
        flag: "🇩🇪",
        gender: "female",
        genderColor: "pink",
        characteristics: {
          tc: "精確 清晰 有幫助",
          sc: "精确 清晰 有帮助",
          en: "Precise Clear Helpful"
        },
        isSelected: false,
        previewUrl: "audio/german_female_1.mp3"
      },
      {
        id: "indian_female_1",
        accentName: {
          tc: "印度口音 (女)",
          sc: "印度口音 (女)",
          en: "Indian Accent (Female)"
        },
        countryCode: "IN",
        flag: "🇮🇳",
        gender: "female",
        genderColor: "pink",
        characteristics: {
          tc: "溫暖 友善 耐心",
          sc: "温暖 友善 耐心",
          en: "Warm Kind Patient"
        },
        isSelected: false,
        previewUrl: "audio/indian_female_1.mp3"
      },
      {
        id: "indian_male_1",
        accentName: {
          tc: "印度口音 (男)",
          sc: "印度口音 (男)",
          en: "Indian Accent (Male)"
        },
        countryCode: "IN",
        flag: "🇮🇳",
        gender: "male",
        genderColor: "blue",
        characteristics: {
          tc: "有幫助 冷靜 溫和",
          sc: "有帮助 冷静 温和",
          en: "Helpful Calm Gentle"
        },
        isSelected: false,
        previewUrl: "audio/indian_male_1.mp3"
      }
    ]
  },

  // Voice Settings
  voiceSettings: {
    id: "voice_settings",
    title: {
      tc: "語調設定",
      sc: "语调设定",
      en: "Voice Settings"
    },
    speed: {
      slow: {
        tc: "慢速",
        sc: "慢速",
        en: "Slow"
      },
      normal: {
        tc: "正常",
        sc: "正常",
        en: "Normal"
      },
      fast: {
        tc: "快速",
        sc: "快速",
        en: "Fast"
      }
    },
    pitch: {
      low: {
        tc: "低音",
        sc: "低音",
        en: "Low"
      },
      normal: {
        tc: "正常",
        sc: "正常",
        en: "Normal"
      },
      high: {
        tc: "高音",
        sc: "高音",
        en: "High"
      }
    }
  },

  // Save Button
  saveButton: {
    id: "save_voice_selection",
    title: {
      tc: "儲存",
      sc: "保存",
      en: "Save"
    },
    color: "brown"
  }
};
